import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * L'entête d'un écran de travail — titre, compteur, actions.
 *
 * 🔴 TROIS PROPS ET `children`, ET C'EST UNE LIMITE VOULUE. Une entête qui
 * accepterait titre, sous-titre, icône, compteur, bouton, libellé du bouton,
 * icône du bouton, action, second bouton, retour, chargement, erreur — douze
 * props — serait un langage de gabarit déguisé, et chaque écran l'emploierait
 * de travers. **Une entête à douze props est pire que cinq entêtes écrites à
 * la main**, parce qu'elle a l'air partagée sans l'être.
 *
 * ⚠️ CE QUI REND LA CONTRAINTE TENABLE : les écrans SANS bouton — Réception et
 * Comptabilité — passent simplement `children` vide. **Ils n'ont pas besoin
 * d'une prop pour ne pas avoir de bouton.** C'est exactement la différence
 * entre un composant et un gabarit : le composant décide de l'ALIGNEMENT, de
 * l'espacement et de la typographie ; il ne décide de rien sur le contenu.
 *
 * Mesuré avant écriture, l'état qui a motivé ce lot : Produits et Commandes
 * avaient titre + bouton, Réception et Comptabilité une icône collée au titre
 * et aucun bouton. On changeait de logiciel en changeant d'onglet.
 *
 *     <EnteteEcran titre={t('products.title')} compteur={total}>
 *       <Button variant="contained" startIcon={<AddIcon />}>…</Button>
 *     </EnteteEcran>
 */
const EnteteEcran = ({ titre, compteur, children }) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: 2,
      mb: 3,
      // ⚠️ La zone d'actions passe SOUS le titre quand la largeur manque, au
      // lieu de comprimer les deux. Sur téléphone, un bouton comprimé descend
      // sous le seuil tactile — la leçon de RU1.
      flexWrap: 'wrap',
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1.5, minWidth: 0 }}>
      {/* ⚠️ `variant="h4"` NU, sans dégradé ni couleur : c'est le traitement
          commun des écrans de TRAVAIL. Le dégradé de marque reste réservé au
          logo et à l'écran de connexion — cf. `Sidebar.js` et `Login.js`. */}
      <Typography variant="h4" component="h1" noWrap>
        {titre}
      </Typography>
      {/* Le compteur est une indication, pas un titre : il suit le texte
          secondaire et ne concurrence pas le titre. `0` doit s'afficher, d'où
          le test sur `null`/`undefined` et non sur la valeur. */}
      {compteur !== undefined && compteur !== null && (
        <Typography variant="body2" color="text.secondary" component="span">
          {compteur}
        </Typography>
      )}
    </Box>

    {/* La zone d'actions. Vide sur Réception et Comptabilité — et c'est bien. */}
    {children ? (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>{children}</Box>
    ) : null}
  </Box>
);

export default EnteteEcran;
